@if (state | async; as vState) {
  <p class="body-copy-md">
    Select a date range and allow members to vote on the best dates for the trip
  </p>
  <form class="form" [formGroup]="rangeForm" (ngSubmit)="save(true)">
    <div
      #errorSummary
      id="errorSummary"
      aria-live="polite"
      aria-atomic="true"
      tabindex="-1"
      class="form-errors">
      @if (rangeForm.touched && rangeForm.invalid && rangeForm.errors) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          @if (rangeForm.hasError("weekDurationMismatch")) {
            <p class="error-message">
              Minimum duration can't exceed the minimum number of straight days
              selected in the week. Currently selected minimum number of
              straight days is
              {{ rangeForm.getError("weekDurationMismatch")["expectedValue"] }}.
            </p>
          }
          @if (rangeForm.hasError("calendarDurationMismatch")) {
            <p class="error-message">
              Minimum duration can't exceed the number of days selected in the
              calendar. Currently selected number of days is
              {{
                rangeForm.getError("calendarDurationMismatch")["expectedValue"]
              }}.
            </p>
          }
        </div>
      }
    </div>
    <span class="body-copy-sm">Select date range</span>
    @let iDates = initialDates();
    @if (iDates) {
      <at-calendar-range-picker
        class="calendar"
        [selected]="iDates"
        [startAt]="iDates.start"
        [minDate]="minStartDate()"></at-calendar-range-picker>
    }
    <div
      aria-live="polite"
      aria-atomic="true"
      tabindex="-1"
      class="form-errors">
      @if (
        rangeForm.controls.start.touched &&
        rangeForm.controls.start.hasError("required")
      ) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          <p class="error-message">Start date is required</p>
        </div>
      }
      @if (
        rangeForm.controls.start.touched &&
        rangeForm.controls.start.hasError("minDate")
      ) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          <p class="error-message">Start date must be in the future</p>
        </div>
      }
    </div>
    <at-form-field label="Minimum duration in days">
      <input type="number" formControlName="minDuration" min="1" />
      <p *atControlError="'minDuration'" class="form-error">
        Minimum duration must be at least 1 day.
      </p>
      <p *atControlError="'required'" class="form-error">
        Minimum duration is required.
      </p>
      <p *atControlError="'min'" class="form-error">
        Minimum duration must be at least 1 day.
      </p>
    </at-form-field>
    <at-weekdays-picker formControlName="weekdays"></at-weekdays-picker>
    @if (isEditing()) {
      <div class="alert warning">
        <div class="icon icon-sm icon-alert-circle"></div>
        <p class="body-copy-sm alert-content">
          You are editing the date range. This
          <strong>
            requires all participants to confirm their availability again
          </strong>
          .
        </p>
      </div>
      <hr />
    }
    <div class="form-actions">
      <button class="button primary" [disabled]="rangeForm.disabled">Set range and notify members</button>
      <button class="button secondary" [disabled]="rangeForm.disabled" type="button" (click)="save()">
        Set dates range
      </button>
      <a class="button tertiary" type="button" [routerLink]="moduleRootPath">
        Discard changes
      </a>
    </div>
  </form>
}
